export default "__VITE_ASSET__Cs1efP7T__"